export function capitalizeFirstLetter(str) {
    const arr = str.split(" ");
    for (var i = 0; i < arr.length; i++)
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    return arr.join(" ");
}

//works only for lower ASCII letters, non-string values return empty string
export function insertSpaceBeforeCapitalLetter(text) {
    if (text == null)
        return null;

    var modText = new Array(text[0]);

    for (var i = 1; i < text.length; i++) {
        if (text[i] >= 'A' && text[i] <= 'Z')
            modText.push(' ');
        modText.push(text[i]);
    }
    return modText.join('');
}

export function parseQueryString(url) {
    var queryString = {};

    var queryIndex = url.indexOf('?');
    if (queryIndex < 0)
        return queryString;

    var query = url.substring(queryIndex + 1, url.length);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        if (typeof queryString[key] === "undefined") {
            queryString[key] = decodeURIComponent(value);
        } else if (typeof queryString[key] === "string") {
            var arr = [queryString[key], decodeURIComponent(value)];
            queryString[key] = arr;

        } else {
            queryString[key].push(decodeURIComponent(value));
        }
    }

    return queryString;
}

export function getParameterCaseInsensitive(params, parName) {
    var pavValue = "";
    if (params == null)
        return pavValue;

    for (const property in params) {
        if (property.toUpperCase() == parName.toUpperCase())
            return params[property];
    }

    return pavValue;
}

export function urlRemoveParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param.toUpperCase() === key.toUpperCase()) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

export function copyObject(source, target) {
    Object.keys(source).forEach(key => {
        target[key] = source[key];
    });
}

export function deepObjectClone(o) {
    //Fast cloning with data loss - JSON.parse / stringify
    //If you do not use Dates, functions, undefined, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas, sparse Arrays, Typed Arrays or other complex types within your object, a very simple one liner to deep clone an object is:

    return JSON.parse(JSON.stringify(o));
}

export function copyToClipboard(textToCopy, htmlToCopy) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'

        const blobText = new Blob([textToCopy], { type: "text/plain" });
        const blobHtml = new Blob([htmlToCopy], { type: "text/html" });        
        const data = [new ClipboardItem({
            ["text/plain"]: blobText,
            ["text/html"]: blobHtml,
        })];


        return navigator.clipboard.write(data);
    } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
}